export enum StudentRegistrationStatusCodes {
  Unknown = 0,
  ReRegistrationDraft = 1,
  RegistrationDraft = 2,
  ReRegistrationSubmitted = 3,
  RegistrationSubmitted = 4,
  Reviewed = 5,
  Migrated = 6,
  Archived = 7,
  SyncFailed = 9,
  Deleted = 10,
}

export const StudentRegistrationStatusNames: { [key: number]: string } = {
  0: 'Unknown',
  1: 'Re-registration in draft',
  2: 'Registration in draft',
  3: 'Re-registration complete',
  4: 'Registration complete',
  5: 'Syncing...',
  6: 'In PASS',
  7: 'Archived',
  9: 'Pass Sync Failed',
  10: 'Deleted',
};
